import GeneralModel from './GeneralModel';
import DrugTypeModel from './DrugTypeModel';
import DrugBoxModel from './DrugBoxModel';
import SocketModel from './SocketModel';
import UserGroupModel from './UserGroupModel';
import BoxCheckModel from './BoxCheckModel';
import UnitModel from "./UnitModel";

let sockets = {};
sockets.user = new SocketModel('user');
sockets.drug = new SocketModel('drug');
sockets.box_check = new SocketModel('box_check');
sockets.drug_box = new SocketModel('drug_box');
sockets.drug_type = new SocketModel('drug_type');
sockets.unit = new SocketModel('unit');
sockets.user_group = new SocketModel('user_group');
sockets.report = new SocketModel('report');

let models = {};

models.drug_type = new DrugTypeModel(sockets.drug_type);
models.user = new GeneralModel('user', sockets.user);
models.drug = new GeneralModel('drug', sockets.drug, null, null, false);
models.box_check = new BoxCheckModel(sockets.box_check);
models.drug_box = new DrugBoxModel(sockets.drug_box);
models.unit = new UnitModel(sockets.unit);
models.user_group = new UserGroupModel(sockets.user_group);
models.report = new GeneralModel('report', sockets.report);
window.models = models;

export default models;



// WEBPACK FOOTER //
// ./src/model/models.js